import { gql } from "@apollo/client";

export const GET_ALL_ESTADO_COMERCIAL = gql`
query GetAllEstadoCondicionalComercial {
    allEstadoCondicionalComercial {
        idEstadoCondicionalComercial
        descripcion
    }
}
`;

export const adaptEstadoComercial = (estadoComercial) => {
  return {
    id: estadoComercial?.idEstadoCondicionalComercial,
    displayName: estadoComercial?.descripcion
  };
};

export const adaptEstadoComercialArray = (
allEstadoCondicionalComercial) =>
{
  return structuredClone(allEstadoCondicionalComercial)?.
  map((estadoComercial) => adaptEstadoComercial(estadoComercial));
};